module.exports = __webpack_public_path__ + "img/feature-playlists@2x.0241c99e.jpg";